import { base } from "./_internal";

/**
 * JoinError
 */
export class JoinError extends base.ApplicationError {
	public static override readonly code: number = 479;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Join error");
		Object.setPrototypeOf(this, trueProto);
	}
}
